import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import BlockIcon from '@mui/icons-material/Block';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const STATUS_BANNER_CONFIG = {
  DONE: {
    icon: CheckCircleOutlineIcon,
    label: 'Submitted',
    description: 'This form has been submitted and is now read-only.',
    color: 'var(--status-green-color)',
    bg: 'var(--status-green-bg)',
    border: 'var(--status-green-border)',
  },
  CANCELLED: {
    icon: CancelOutlinedIcon,
    label: 'Cancelled',
    description: 'This form has been cancelled and can no longer be submitted.',
    color: 'var(--color-text-secondary)',
    bg: 'var(--color-bg-subtle)',
    border: 'var(--color-border)',
  },
  LOCKED: {
    icon: LockOutlinedIcon,
    label: 'Locked',
    description: 'This form is locked and cannot be edited.',
    color: 'var(--status-amber-color)',
    bg: 'var(--status-amber-bg)',
    border: 'var(--status-amber-border)',
  },
  VIEW_ONLY: {
    icon: BlockIcon,
    label: 'View only',
    description: 'This form is view-only and cannot be submitted.',
    color: 'var(--color-text-secondary)',
    bg: 'var(--color-bg-subtle)',
    border: 'var(--color-border)',
  },
};

export function resolveFormStatusBannerKey(form) {
  if (!form) return null;
  if (form.progressStatus === 'DONE') return 'DONE';
  if (form.progressStatus === 'CANCELLED') return 'CANCELLED';
  if (form.locked) return 'LOCKED';
  if (form.responseMode === 'VIEW_ONLY') return 'VIEW_ONLY';
  return null;
}

export default function FormStatusBanner({ status }) {
  const config = STATUS_BANNER_CONFIG[status];
  if (!config) return null;
  const Icon = config.icon;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2.5,
        py: 2,
        borderRadius: '12px',
        bgcolor: config.bg,
        border: `1px solid ${config.border}`,
      }}
    >
      <Icon sx={{ fontSize: 22, color: config.color, flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: config.color, lineHeight: 1.3 }}>
          {config.label}
        </Typography>
        <Typography
          sx={{ fontSize: 12, color: config.color, opacity: 0.85, lineHeight: 1.4, mt: 0.25 }}
        >
          {config.description}
        </Typography>
      </Box>
    </Box>
  );
}
